import React, { useMemo } from "react";

import { SearchspringFacet } from "@app/types";

import { Icon } from "@app/components/icon";

type Props = {
  filter: SearchspringFacet;
  fetchedFilters: SearchspringFacet[];
  activeFilters: Set<string>;
  onFilter: any;
};

export function ResultFilter({ filter, activeFilters, fetchedFilters, onFilter }: Props) {
  if (!filter) return null;

  const fetchedFilter = useMemo(() => {
    return fetchedFilters.find((current) => current.field === filter.field);
  }, [fetchedFilters]);

  const values = useMemo(() => {
    return (
      filter.values.map((item) => {
        // TODO: range delimiter here should be provided somewhere else
        // @ts-ignore
        const value = item.type === "range" ? `${item.low}<>${item.high}` : item.value;
        const valueWithKey = `${filter.field}:${value}`;

        const fetchedValue = fetchedFilter?.values?.find((currentValue) => {
          return currentValue.label === item.label;
        });

        return {
          label: item.label,
          value: valueWithKey,
          count: fetchedValue?.count,
          checked: activeFilters.has(valueWithKey),
          disabled: !fetchedValue,
        };
      }) ?? []
    );
  }, [filter, activeFilters, fetchedFilter]);

  const selectedValues = values?.reduce((sum, value) => (value.checked ? sum + 1 : sum), 0);

  //   if (!values.length === 0) return null;

  return (
    <div x-data="toggler" className="group flex flex-col gap-4 transition-all ui-[hidden]:gap-0">
      <button x-bind="toggle" className="flex items-center justify-between w-full">
        <span className="flex items-center gap-2">
          <span className="capitalize h5">{filter.label}</span>
          {selectedValues > 0 && (
            <span className="flex items-center justify-center font-medium rounded-full text-label size-6 bg-neutrals-grey-5">
              {selectedValues}
            </span>
          )}
        </span>
        <div>
          <Icon id="Plus" className="hidden size-4 group-ui-[hidden]:block" />
          <Icon id="Minus" className="block size-4 group-ui-[hidden]:hidden" />
        </div>
      </button>
      <div className="no-scrollbar grid max-h-96 grid-cols-2 items-center gap-x-4 gap-y-1 overflow-y-scroll transition-all group-ui-[hidden]:max-h-0">
        {values.map((value) => {
          return (
            <div className="field field-checkbox !h-fit py-2 hover:*:cursor-pointer" key={value.value}>
              <input
                type="checkbox"
                className="border-2 field-control h-fit w-fit shrink-0 border-neutrals-black bg-neutrals-white"
                id={value.value}
                name={value.value}
                checked={value.checked}
                disabled={value.disabled}
                onChange={() => onFilter(value.value)}
              />
              <label htmlFor={value.value} className="flex items-center gap-1 text-body-md">
                <span>{value.label}</span>
                <span className="text-neutrals-grey-2">({value.count})</span>
              </label>
            </div>
          );
        })}
      </div>
    </div>
  );
}
